const Fraud = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="text-[40px] font-bold">Fraud Prevention</h1>
      </div>
      <div className="flex flex-col justify-center items-center gap-8 max-w-[50rem] mx-auto text-left p-[3rem]">
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum unde
          maxime reprehenderit, provident, aut sint fuga nisi aliquam nesciunt,
          facere repellat natus officiis mollitia laboriosam amet perspiciatis
          iste alias! Vel reiciendis quasi quisquam similique minus impedit, eum
          non pariatur, incidunt earum quos laborum aspernatur minima illum.
          Deleniti delectus iure esse.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum unde
          maxime reprehenderit, provident, aut sint fuga nisi aliquam nesciunt,
          facere repellat natus officiis mollitia laboriosam amet perspiciatis
          iste alias! Vel reiciendis quasi
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum unde
          maxime reprehenderit, provident, aut sint fuga nisi aliquam nesciunt,
          facere repellat natus officiis mollitia laboriosam amet perspiciatis
          iste alias! Vel reiciendis quasi quisquam similique minus impedit, eum
          non pariatur, incidunt earum quos laborum aspernatur minima illum.
          Deleniti delectus iure esse. Vel reiciendis quasi quisquam similique
          minus impedit, eum non pariatur, incidunt earum quos laborum
          aspernatur minima illum. Deleniti delectus iure esse.
        </p>
      </div>
    </div>
  );
};

export default Fraud;
